import React from 'react'
import PostBody from './PostBody'
import { IData } from '@/components/blogImg'

interface IProps {
  post: IData
  isFirst: boolean
}

const PostComponent = (props: IProps) => {
  const { post, isFirst } = props
  return (
    <div className='rounded-2xl overflow-hidden transition-shadow'>
      <PostBody post={post} isFirst={isFirst} />
    </div>
  )
}

export default PostComponent
